import { render, staticRenderFns } from "./Transform.vue?vue&type=template&id=6dcb2460&scoped=true&"
import script from "./Transform.vue?vue&type=script&lang=js&"
export * from "./Transform.vue?vue&type=script&lang=js&"
import style0 from "./Transform.vue?vue&type=style&index=0&id=6dcb2460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb2460",
  null
  
)

export default component.exports